import { Controller } from "@hotwired/stimulus"

// Plausible custom events for the public site (doc-44 §4, TASK-282).
//
// Plausible is cookie-less, so there is no consent banner to wire; the
// script itself is loaded by layouts/www only when PLAUSIBLE_DOMAIN is set,
// and this controller does nothing at all when `window.plausible` is absent
// (development, specs, an ad blocker). Four events, named in the plan:
//
//   trial-start      a Start free trial control was clicked
//   demo-start       a Book a demo control was clicked (the one door while
//                    ENABLE_TRIAL is off, decision-107)
//   demo-request     the demo form was submitted (fired by the thank-you page)
//   app-store-click  an App Store / Play link was clicked
//   demo-form-view   the demo form was shown
//
// Usage: `data-controller="www-analytics"` sits on <body>, so any descendant
// may declare `data-action="click->www-analytics#track"
// data-www-analytics-event-param="trial-start"`. A page-level event goes on
// an element with `data-www-analytics-target="pageEvent"
// data-event="demo-form-view"` and fires once when that element connects.
export default class extends Controller {
  static targets = ["pageEvent"]

  pageEventTargetConnected(element) {
    this.send(element.dataset.event)
  }

  track(event) {
    this.send(event.params.event)
  }

  send(name) {
    if (!name) return
    if (typeof window.plausible !== "function") return

    window.plausible(name)
  }
}
